/**
 * Configuração do React Query Client
 * Define estratégias globais de cache, retry, etc.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Tempo que os dados são considerados "frescos" (não faz refetch automático)
      staleTime: 5 * 60 * 1000, // 5 minutos
      
      // Tempo que os dados ficam no cache após não serem usados (antes gcTime)
      gcTime: 10 * 60 * 1000, // 10 minutos
      
      // Não refetch ao focar a janela (evita requisições desnecessárias)
      refetchOnWindowFocus: false,
      
      // NÃO refetch ao montar componente se já tiver cache (IMPORTANTE para cache funcionar)
      refetchOnMount: false,
      
      // Refetch ao reconectar (útil para apps que podem ficar offline)
      refetchOnReconnect: true,
      
      // Número de tentativas em caso de erro
      retry: 2,
      
      // Delay entre tentativas (exponencial backoff)
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      // Retry em mutações (geralmente não recomendado, mas configurável)
      retry: 1,
    }
  }
});

